import { IRestModel, RestApi } from '@nkr/utils/rest-api';

export interface IMedicalRecord extends IRestModel {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    dob: string
}

export const useMedicalRecordApi = (centerId: number) => {
    return new RestApi<IMedicalRecord, IMedicalRecord>(`${__API__}/center/{centerId}/medical-record`)
        .setRouteParams({ centerId })
        .makeHooks();
}
